module.exports = __webpack_public_path__ + "img/horizontal_3_5_pp23_8004.044536d7.png";